import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";
import { useEffect } from "react";

//Components
import { Modal, ModalBody, ModalFooter, Button, Tooltip } from "@gpstrackit/react-controls";
import { NotificationManager } from 'Components/Notifications';
import { Alert } from '@mui/material';

//Actions
import {
    clearRedux,
    notesDeleteRequest,
} from 'Redux/actions';

//Permission
import { HasPermission } from "Core/security"

const DeleteNote = (props) => {
    const { tableRef } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const { openModal, loading, result, note } = useSelector(state => state.deleteNoteRedux);
    const user = useSelector(state => state.securityRedux.user);
    const closeModal = () => {
        dispatch(clearRedux("NOTES_DELETE"));
    }

    const applyChanges = () => {
        note && dispatch(notesDeleteRequest(note?.id));
    }

    useEffect(() => {
        if (result?.delete) {
            NotificationManager.success(
                messages['delete_note_success_message'],
                messages['delete_note_title'],
                3000
            );
            tableRef && tableRef.current?.getData();
            closeModal();
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['delete_note_title']}
            handleClose={() => closeModal()}
            position="right"
            loading={loading}
            size="small"
        >
            <ModalBody>
                <div style={{ padding: '0 10px' }}>
                    <p style={{ margin: 0 }}>{messages['delete_note_label']}</p>
                    {
                        note?.note ?
                            <ul style={{ marginTop: 10 }}>
                                <li>
                                    {
                                        note?.note?.length < 50 ? note?.note :
                                            <Tooltip title={note?.note}>
                                                <div>
                                                    {note?.note.substring(0, 50)}
                                                </div>
                                            </Tooltip>
                                    }
                                </li>
                            </ul>
                            : <></>
                    }
                    <Alert
                        style={{ marginTop: 5 }}
                        severity="warning"
                    >
                        {messages['delete_note_warning']}
                    </Alert>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                {
                    HasPermission(user, "note", "d") &&
                    <Button
                        className="btn-dark-blue"
                        onClick={() => applyChanges()}
                    >
                        {messages['delete']}
                    </Button>
                }
            </ModalFooter>
        </Modal>
    )
}

export default DeleteNote;